import { VueConstructor } from 'vue'

const r = require.context('.', false, /\.vue$/)
const components: Record<string, VueConstructor> = r
  .keys()
  .reduce((ret, key) => {
    const name = key.match(/([a-zA-Z]+)\.vue$/)![1]
    return { ...ret, [name]: r(key).default }
  }, {})

export default {
  install(Vue: VueConstructor) {
    Object.entries(components).forEach(([name, Component]) => {
      Vue.component(name, Component)
    })
  }
}
